import { Component } from '@angular/core';
@Component({
    selector: 'app-mysec-layout',
    templateUrl: './mysec-layout.component.html',
    styleUrls: ['./mysec-layout.component.scss'],
    standalone: false
})
export class MysecLayoutComponent {}
